<template>
  <div class="wrap">
    <div class="left">

      <el-form ref="form" :model="form" label-width="80px">
        <!-- <el-form-item label="活动区域">
          <el-select v-model="form.region" placeholder="请选择活动区域" style="width: 100%;">
            <el-option label="区域一" value="shanghai"></el-option>
            <el-option label="区域二" value="beijing"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="筛选时间" >
          <el-date-picker
            v-model="showDate"
            style="width: 100%;"
            type="datetimerange"
            :picker-options="form.pickerOptions"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            align="right">
          </el-date-picker>
        </el-form-item>
        <el-form-item class="function-wrap">
          <el-button @click="exportData" :disabled="!hasData|| loading" :loading="loading">{{loading?'导出中':'导出'}}</el-button>
          <el-button type="primary" @click="queryChartData">确认</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="right">
      <div class="title">
        <!-- 标题 -->
        <!-- 统计函数为总数：展示总数。非总数，展示统计度量file对应的物模型的名字 -->
        {{title}}
      </div>
      <div class="echart">
        <pieCharts
          :performType="performType"
          :centerTitle="performTypeList[performType]"
          :title="pieTitle"
          v-if="chartData"
          :data="chartData"/>
      </div>
    </div>
  </div>
</template>
<script>
import pieCharts from './pieCharts'
import { dateHelper, loadFileByUrl } from '@/utils'
import { dateFormat } from '@/assets/js/tools'
import { mapData, exportDataFile } from '@/api/dataStatistics'
import { thingModel } from '@/api/deviceManagement'

export default {
  props: ['taskId', 'taskDetail'],
  components: {
    pieCharts
  },
  data () {
    return {
      form: {
        name: '',
        region: '',
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近三个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }],
          disabledDate (time) {
            const dateArr = dateHelper.getRecentYear('number')
            return (time.getTime() > dateArr[1] || time.getTime() < dateArr[0] - 8.64e6)
          }
        }
      },
      // showDate: this.dateSel,
      showDate: ['', ''],
      loading: false, // 表示是否正正在导出表格,
      initQueryPieParams: { // 查询饼状图的参数,这个定义在date下，每个table下，保证每个图表有独立的参数空间
        params: {
          taskId: this.taskId,
          beginTime: '',
          endTime: '',
          period: 3, // 2按日// period为3默认按月汇总
          pageNumber: 1,
          pageSize: 100000// 尽量取最大，反正饼状图需要取回全部数据才能绘制
        }
      },
      chartData: null,
      thingModel: null, // 物模型数据
      title: '', // this.taskDetail.performType.toString() === '0' ? '总数' : '',
      pieTitle: '',
      groupName: '', // 用于保存分组名
      fileName: '', // 用于保存计算度量对应的item
      // 统计函数列表
      performTypeList: {
        0: '总数',
        1: '最大值',
        2: '最小值',
        3: '求和',
        4: '平均'
      },
      performType: ''
    }
  },
  async created () {
    console.log('this.taskDetail:', this.taskDetail)
    const dateArr = dateHelper.getRecentYear()
    this.showDate = [dateArr[0], dateArr[1]]
    // 先请求物模型数据
    // 不是以设备分组的获取对应物模型的分组名
    // if (this.taskDetail.groupField !== 'device_name') {
    await this.getThingModel()
    // }

    this.requestPieData()
  },
  methods: {
    getGroupItem (fieldList) {
      console.log('调用了getGroupItem')
      // 获取分组对象
      const typeList = {
        1: 'properties',
        2: 'events',
        3: 'services'
      }
      let list = ''
      if (this.taskDetail.type.toString() === '1') { // 属性
        list = this.thingModel[typeList[this.taskDetail.type]]
      } else {
        list = this.thingModel[typeList[this.taskDetail.type]].outputData
      }
      console.log('list:', list)
      console.log('this.taskDetail:', this.taskDetail)
      const getItem = function (index, list) {
        let item = ''
        let i = 0
        while (i < list.length) {
          if (list[i].identifier === fieldList[index]) {
            item = list[i]
            console.log('找到了item：', item)
            if (index < fieldList.length && item.dataType.type === 'struct') {
              getItem(index++, item.dataType.specs)
            } else if (index < fieldList.length && item.dataType.type === 'array') {
              if (item.dataType.specs.item.type === 'struct') {
                getItem(index++, item.dataType.specs.item.specs)
              } else {
                console.log(88888)
                return item
                // return item.dataType.specs
              }
            } else {
              console.log(88888)
              return item
              // return item.dataType.specs
            }
            break
          }
          i++
        }
      }
      const groupName = getItem(0, list)
      console.log('获取的groupName：', groupName)
      return groupName
    },
    async getThingModel (pieChartData) {
      const params = {
        productKey: this.taskDetail.productKey
      }
      console.log('getThingModel params:', params)
      this.key2chinese = {}
      this.dataList = []
      await thingModel(params).then(res => {
        res = res.data
        console.log('外层物模型数据：', res)
        this.thingModel = res.data.thingModel
        // 获取非数值统计维度(即分组对应的物模型)
        // 不是以设备分组
        if (this.taskDetail.groupField !== 'device_name') {
          const groupFieldList = this.taskDetail.groupField.split('.')
          const groupItem = this.getGroupItem(groupFieldList)
          this.pieTitle = groupItem.name
          this.groupName = groupItem.dataType.specs
          console.log('groupName:', this.groupName)
        } else {
          this.pieTitle = '设备名'
        }

        const fieldList = this.taskDetail.field.split('.')
        const fileItem = this.getGroupItem(fieldList)
        // 非总数统计展示对应统计度量的名字
        // if (this.taskDetail.performType.toString() !== '0') {
        //   this.title = fileItem.name
        // }
        this.fileName = fileItem.dataType.specs
        console.log('fileName:', this.groupName)
      }).catch(() => {
        this.chartData = pieChartData
      })
      console.log('await后面')
    },
    exportData () {
      this.initQueryPieParams.params.beginTime = dateFormat(this.showDate[0])
      this.initQueryPieParams.params.endTime = dateFormat(this.showDate[1])
      const params = this.initQueryPieParams.params
      this.loading = true
      setTimeout(function () {
        this.loading = false
      }, 10000)
      exportDataFile(params).then(res => {
        res = res.data
        console.log('返回的下载数据：', res)
        if (res.data) {
          // window.open(res.data)
          loadFileByUrl(res.data)
        } else {
          this.$message.error('下载出错')
        }
        this.loading = false
      })
    },
    queryChartData () {
      if (this.showDate && this.showDate[0]) {
        console.log(8888)
        this.initQueryPieParams.params.beginTime = this.showDate[0]
        this.initQueryPieParams.params.endTime = this.showDate[0]
        this.requestPieData()
      } else {
        this.$message({
          type: 'info',
          message: '请先选择日期'
        })
      }
    },
    requestPieData (query) { // 请求饼状图数据
      this.initQueryPieParams.params.pageNumber = 1// 每次请求页码重置为1
      this.initQueryPieParams.params.beginTime = dateFormat(this.showDate[0])
      this.initQueryPieParams.params.endTime = dateFormat(this.showDate[1])
      const params = this.initQueryPieParams
      const pieMapData = {}// 将每次请求回来的数据以组名来统计总数
      const that = this
      // 回调函数
      const callBack = function (res) {
        res = res.data
        console.log('子组件请求回来的饼状图数据：', res)
        const currentPieChart = res.data.list && res.data.list.length > 0 && res.data.list[0] ? res.data.list[0] : []
        that.performType = currentPieChart.performType ? currentPieChart.performType : ''
        const record = currentPieChart.recordLists ? currentPieChart.recordLists : []
        console.log('获取的groupName：', that.groupName)
        record.forEach(item => {
          if (that.taskDetail.groupField !== 'device_name') { // 不是以设备来分组
            const dayKey = item.groupName// 将groupName作为key,对应的count进行累计统计
            const nameKey = that.groupName[dayKey] ? that.groupName[dayKey] : dayKey
            pieMapData[nameKey] = pieMapData[nameKey] ? (parseFloat(pieMapData[nameKey]) + item.count) : item.count
          } else {
            const dayKey = item.groupName// 将groupName作为key,对应的count进行累计统计
            pieMapData[dayKey] = pieMapData[dayKey] ? (parseFloat(pieMapData[dayKey]) + item.count) : item.count
          }
        })
        if (params.pageNumber < (res.total / params.pageSize)) {
          params.pageNumber++
          getData()// 递归请求
        } else { // 递归结束
          console.log('结束递归')
          // 将数组整理成饼状图需要的数据
          const pieChartData = that.factorPieData(pieMapData)
          console.log('整理好的数据：', pieChartData)
          that.$set(that, 'chartData', pieChartData)
        }
      }
      // 递归函数
      const getData = function () {
        console.log('this.initQueryPieParams:', JSON.stringify(that.initQueryPieParams))
        console.log('请求前的Params:', JSON.stringify(params))
        mapData(params).then(callBack)
      }
      getData()
      // await mapData(params).then()
      // console.log('递归请求结束')
    },
    // 将饼状图需要的数据构造好直接返回
    factorPieData (chartData) {
      console.log('chartData===pie:', chartData)
      const pieData = { kinds: [], data: [], total: 0 }
      Object.keys(chartData).forEach(key => {
        pieData.kinds.push(key)
        pieData.data.push({ value: chartData[key], name: key })
        pieData.total += chartData[key]
      })
      return pieData
    }
  },
  watch: {

  },
  mounted () {
    console.log('传入taskDetail的数据：', this.taskDetail)
  },
  computed: {
    hasData () {
      return (this.chartData && this.chartData.kinds && this.chartData.kinds.length > 0)
    }
  }
}
</script>

<style lang='less' scoped>
  .wrap{
    display: flex;
    justify-content: space-between;
    height: 600px;
    padding: 50px 40px 70px 20px;
    .left{
      padding: 70px 50px 0 0px;
      width: 30%;
      border-right: 2px solid #D5D5D5;
      .el-date-editor--datetimerange.el-input, .el-date-editor--datetimerange.el-input__inner {
          width: 0px;
      }
      .el-date-editor.el-input, .el-date-editor.el-input__inner {
          width: 0px;
      }
      .function-wrap{
        margin-top: 80px;
        text-align: center;
      }
    }
    .right{
      width: 70%;
      padding: 0 0px 30px 60px;
      .title{
        line-height: 50px;
        border-bottom: 2px solid#D5D5D5;
      }
      .echart{
        width: 70%;
        height: 100%;
      }
    }
    .function{
      position: absolute;
      right: 10px;
      top: 10px;
    }
  }
</style>
